import { AircraftSearchResultsView } from '@/features/AssetDetailView/AircraftSearch/AircraftSearchResultsView';
import { validateAircraftSearchSearch } from '@/features/AssetDetailView/AircraftSearch/searchParams';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/asset_collection/assets/$assetId/projects/$projectId/search/',
)({
    component: AircraftSearchResultsView,
    validateSearch: validateAircraftSearchSearch,
});
